import React from 'react';
import Button from '../../components/Button/Button';
import { PortalWithState } from 'react-portal';
import { IdArrayInput } from '../../hooks/useTablePages';
import RequirePerms from '@/components/RequirePerms';
import BulkTagModal from '../../components/TagPicker/BulkTagModal';

type CustomersActionsProps = { selectedIds: IdArrayInput };

const CustomersActions: React.FC<CustomersActionsProps> = ({
  selectedIds,
}): JSX.Element => {
  return (
    <>
      <RequirePerms customers="UPDATE">
        <PortalWithState closeOnOutsideClick closeOnEsc>
          {({ openPortal, closePortal, portal }) => (
            <>
              <Button
                variant="outline"
                disabled={!selectedIds.length}
                icon="plus-circle"
                onClick={openPortal}
              >
                Add Tags
              </Button>
              {portal(
                <BulkTagModal
                  selectedIds={selectedIds}
                  objectType="customer"
                  onClose={closePortal}
                />
              )}
            </>
          )}
        </PortalWithState>
      </RequirePerms>
    </>
  );
};

export default CustomersActions;
